<template style="height: 100%;">
  <div class="Testreport" id="prints">
    <div class="userreport"  style="page-break-before:always;" v-loading="loading" v-for="(item,i) in data" :key="i">
      <div class="se" v-html="item.PaperReReportName"></div>
      <div v-html="item.PaperReRepPerlDetails"></div>
      <div @click="eventTemp" v-html="item.PaperReReportContent"></div>
      <div class="wdiv">
        <h2>结论</h2>
        <el-input type="textarea" maxlength="500" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
      </div>
      <div v-html="item.PaperReRepAffContent"></div>
      <div v-html="item.PaperReRepAttaContent"></div>
      <br>
    </div>
    <!-- <el-button v-if="ksuai" type="primary" @click="outup" class="outup">导出</el-button>
    <el-button type="primary" @click="outup2" class="outup2">保存</el-button> -->
    <el-button v-if="ksuai" type="primary" @click="outup3" class="outup3">打印</el-button>
    <el-dialog :title="ScoreTips[ScoreTipIndex].title" :visible.sync="dialogVisible" width="500">
      <p class="dialog-score-tip">{{ ScoreTips[ScoreTipIndex].nav }}</p>
      <p class="dialog-score-tip">{{ ScoreTips[ScoreTipIndex].en }}</p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ksuai: true,
      PublishID: [],
      textarea: '',
      PaperReRepAffContent: '',
      PaperReRepAttaContent: '',
      PaperReRepPerlDetails: '',
      PaperReReportContent: '',
      PaperReReportName: '',
      loading: true,
      PaperResultID: [],
      from: {
        Name: '',
        Student: '',
        ScaleName: '',
        TestTime: [],
        PublishID: '',
        ObjectS: '',
        DeptID: '',
        StudyTime: '',
        Warning: [],
      },
      ScoreTipIndex: 0,
      ScoreTips: [
        {
          title: '原始分介绍',
          nav:'原始分是根据问卷答题直接计算得来的分数。由于原始分的不等性和不确定性，原始分通常是无意义的，需要转换为标准分后，方可帮助测试者判断理解自身的心理水平。',
          en: 'The raw score is directly calculated based on your answers in the questionnaire. However, the raw score is usually meaningless. It needs to be converted to a standard score to help the subject to understand his/her psychological status.'
        },
        {
          title: '标准分介绍',
          nav:'标准分是由原始分转化而得来，是测试结果中测试者真正应当关注的分数。测试者需依据标准分来在结果分值范围内判断自身的心理水平。如分值范围为0-10，标准分为6分，说明测试者是在10分制下得了6分。',
          en: 'The standard score, to which is the score a page-break-before:always; should pay attention, is converted from the raw score. A subject needs to understand his/her psychological status based on the standard score. For example, if the score range is from 0 to 10, and the standard score is 6, then it indicates that the subject scored 6 points on a 10-point system.'
        }, {
          title: '均分介绍',
          nav: '均分是原始分的平均值，测试者可依据均分大概了解量表反映的心理水平的集中趋势；如分值范围为1-10，均分为2，说明测试者更倾向于低分值所代表的心理水平。',
          en: 'The mean score is the mean value of the original score, according to which the test subject can approximate the central tendency level of their psychological level based on the scale taken. If the mean score of the scale is set to a range from 1 to 10, and the mean score of the test subject is 2, it indicates that the subject is inclined to have the psychological level represented by the lower score.'
        }
      ],
      data:[],
      dialogVisible: false
    }
  },
  methods: {
    eventTemp(e) {//根据点击元素类名触发事件
      if (e.target.className === 'scoreSrc el-icon-question Src') {
        this.dialogVisible = true;
        this.ScoreTipIndex = 0;
      } else if (e.target.className === 'scoreSrc el-icon-question Stand') {
        this.dialogVisible = true;
        this.ScoreTipIndex = 1;
      } else if (e.target.className === 'scoreSrc el-icon-question Avg') {
        this.dialogVisible = true;
        this.ScoreTipIndex = 2;
      }
    },
    outup() {
      this.$Http_Post('ScaleIssue/GetScaleMeasured', { pageSize: '10', pageIndex: '1', Nation: '', ScaleName: '', Sex: '', Study: '', IfS: '1', IfS: '1', IfSPublishID: this.PaperResultID, from: this.from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (res.Data == '无此文件') {
            this.Global.request_failure('无此文件');
          } else {
            window.location = res.Data;
          }
        }
      })
    },
    outup2() {
      this.$Http_Post('ScaleIssue/Update_PaperResult', { Diagnosis: this.textarea, PaperResultID: this.PaperResultID, }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    outup3() {
      this.ksuai = false;
      setTimeout(function () {
        let htmlcontent = document.body.appendchildren;
        document.body.appendchildren = document.getElementById('prints').innerHTML;
        window.print();
        document.body.appendchildren = htmlcontent;
        document.getElementById('prints').click = this.outup3;
      }, 100)
    },
  },
  mounted() {
    window.addEventListener('afterprint', () => {//监听打印和打印取消按钮
      this.ksuai = true;
    });
    if([this.$route.query.PaperResultIDlist][0]){
      for(var i = 0;i<[this.$route.query.PaperResultIDlist][0].length;i++){
        this.$Http_Post('ScaleIssue/Get_PaperResultReport', {TerminalType: 'PC',PaperResultID: [this.$route.query.PaperResultIDlist][0][i]}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.data.push(res.Data[0]);
            this.loading = false;
          }
        })
      }
    }else{
      let a = [this.$route.query.PaperResultID];
      this.PaperResultID = [this.$route.query.PaperResultID];
      this.from.PublishID = this.$route.query.PublishID;
      this.param = a;
      this.$Http_Post('ScaleIssue/Get_PaperResultReport', {TerminalType: 'PC',PaperResultID: this.$route.query.PaperResultID,}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data.push(res.Data[0])
          this.loading = false
        }
      })
    }
  },
}
</script>
<style>
.wdiv {height: 120px;}
.wdiv .el-textarea__inner {width: 900px;margin: 0 auto;height: 80px;resize: none;}
.wdiv .el-textarea {width: 900px;margin: 0 auto;display: inline;height: 80px;resize: none;}
.wdiv h2 {text-align: left;font-size: 17px;font-weight: bold;padding-top: 15px;padding-bottom: 8px;color: #5b9bd5;}
div,ul,li,span,input,p {padding: 0px;margin: 0px;border: 0px;}
.userreport {width: 1024px;margin: 0 auto;box-shadow: 10px 10px 15px #888888;padding: 10px;background: url('../../../assets/bgc1227191745.png') repeat center;min-height: 800px;position: relative;}
.userreport-message {margin: 30px 10px 30px 10px;font-family: 'Microsoft YaHei';}
.userreportname {text-align: center;font-size: 18px;font-family: 'Microsoft YaHei';color: #5b9bd5;font-weight: bold;}
.userreport-title {text-align: left;font-size: 17px;font-weight: bold;padding-top: 15px;padding-bottom: 8px;color: #5b9bd5;}
.userreport-content-header {width: 100px;text-align: right;font-size: 16px;color: #5b9bd5;}
.userreport-content.table tr th,.userreport-content.table tr td {height: 30px;vertical-align: text-top;}
/*个人信息*/
table.userreport-content-userInfo {width: 900px;margin: 0 auto;border-collapse: collapse;}
table.userreport-content-userInfo tr td {width: 200px;border: solid 1px #5b9bd5;}
table.userreport-content-userInfo tr th {width: 120px;padding: 5px;border: solid 1px #5b9bd5;}
table.userreport-content-userInfo tr td,table.userreport-content-userInfo tr th {vertical-align: middle;padding-right: 20px;}
/*个人病例样式*/
.userreport-content-case-content,.userreport-content-attanswer {list-style: none;margin: 0 auto;}
/*测试结果*/
.userreport-content-testresult th {background: #5b9bd5;color: #ffffff;}
table.userreport-content-testresult th,table.userreport-content-testresult td,table.userreport-content-testresult {border: 1px solid #5b9bd5;border-collapse: collapse;}
table.userreport-content-testresult tr th,table.userreport-content-testresult tr td {padding: 5px;height: 20px;vertical-align: middle;}
.userreport-content-testresult-title {width: 200px;}
.userreport-content-testresult {text-align: center;margin: 0 auto;}
/*附属内容*/
.userreport-content-header-auxiliary {color: #5b9bd5;font-weight: bold;margin-right: 10px;}
.userreport-content-row-auxiliary-bottom-left,.userreport-content-row-auxiliary-bottom-right {display: inline-block;width: 450px;}
.userreport-content-row-auxiliary-bottom-right {text-align: right;}
.diagnosis {height: 30px;border: 0px;border-bottom: 1px solid Black;opacity: 0.5;width: 900px;}
#txtDiagnosis {height: 100px !important;font-size: 16px;}
.divesign {border: 0px;border-bottom: 1px solid Black;opacity: 0.5;height: 30px;width: 150px;text-align: center;}
.esign {max-height: 30px;max-width: 150px;}
/*彩虹图，彩带图 设置样式*/
.userreport-content-title {height: 40px;text-align: center;}
/*彩带图*/
span,tr,td,div,img {padding: 0px;margin: 0px;border: 0px;}
.userreport-btn {text-align: right;padding: 10px;top: 5px;margin: 0 auto;padding: 10px;position: fixed;right: 0px;margin-left: auto;margin-right: auto;height: 50px;}
.teshuccs {font-size: 15px;font-family: 'Microsoft YaHei';font-weight: inherit;}
.freehand-sketching {text-align: center;padding-bottom: 15px;}
.userreport-content-center {text-align: center;}
.userreport-factor {text-align: left;font-size: 16px;font-weight: bold;padding-top: 15px;padding-bottom: 8px;}
.btn {
  display: inline-block;
  *display: inline;
  margin-bottom: 0;
  *margin-left: 0.3em;
  padding: 9px 14px;
  font-size: 20px;
  line-height: normal;
  color: #333;
  text-align: center;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
  vertical-align: middle;
  cursor: pointer;
  background-color: #c7e7fe;
  *background-color: #6dd7ff;
  background-image: -ms-linear-gradient(top, #d2ecfe, #6dd7ff);
  background-image: -webkit-gradient(linear,
      0 0,
      0 100%,
      from(#d2ecfe),
      to(#6dd7ff));
  background-image: -webkit-linear-gradient(top, #d2ecfe, #6dd7ff);
  background-image: -o-linear-gradient(top, #d2ecfe, #6dd7ff);
  background-image: linear-gradient(top, #d2ecfe, #6dd7ff);
  background-image: -moz-linear-gradient(top, #d2ecfe, #6dd7ff);
  background-repeat: repeat-x;
  border: 1px solid #c2e6ff;
  *border: 0;
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  border-color: #6dd7ff #6dd7ff #adddff;
  border-bottom-color: #92d2ff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  filter: progid:dximagetransform.microsoft.gradient(startColorstr='#ffffff', endColorstr='#6dd7ff', GradientType=0);
  filter: progid:dximagetransform.microsoft.gradient(enabled=false);
  *zoom: 1;
  -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
}
.report-tip {margin: 30px 10px 30px 30px;list-style: square;}
.report-tip li {line-height: 25px;}
.se {text-align: center;font-size: 18px;font-family: 'Microsoft YaHei';color: #5b9bd5;font-weight: bold;}
.outup {position: fixed;right: 15px;top: 100px;}
.outup2 {position: fixed;right: 15px;top: 140px;}
.outup3 {position: fixed;right: 15px;top: 180px;}
.plpkp {display: none;}
.system_name {display: none;}
.el-tabs__nav-scroll {display: none;}
.el-header {display: none;}
.dialog-score-tip {line-height: 25px;text-indent: 2em;}
</style>
